/**
 * The Faq container
 */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import faqsActions from "../../redux/faqs";
import { push } from "connected-react-router";
import FaqView from "../../components/FaqView";
import Page from "../../components/Page";

import LoadingContent from "../../components/LoadingContent";
import { Container, Row, Col } from "reactstrap";
import FaqAutocompleteSearch from "../../components/FaqAutocompleteSearch";
import { useSsrEffect } from "@issr/core";

/**
 * Selects props from the store and passes them to the component
 * @param {Object} state the store
 */
const mapStateToProps = (state) => ({
  faq: state.faqs.show,
  loadingShow: state.faqs.loadingShow,
  loadedShow: state.faqs.loadedShow,
  showError: state.faqs.showError,
  language: state.i18nState.lang,
});
/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showFaq: faqsActions.show,
      storeFaq: faqsActions.storeFaq,
      unstoreFaq: faqsActions.unstoreFaq,
      navigateTo: push,
    },
    dispatch
  );

/**
 * The `show` container for an Faq.
 * Both the component and the connected component are exported for testing purpose
 */
const Faq = (props, context) => {
  const faqSlug = props.match ? props.match.params.slug : false;
  const {
    loadingShow,
    showFaq,
    faq,
    language,
    showError,
    navigateTo,
    loadedShow,
  } = props;

  const frontload = async () => {
    if (
      (!faq || (faq && (faq.language !== language || faq.slug !== faqSlug))) &&
      !loadingShow &&
      !(showError && showError.slug === faqSlug)
    ) {
      showFaq(faqSlug);
    } else if (!loadingShow && showError && showError.slug === faqSlug) {
      navigateTo(`/${language}/faqs/`);
    }
  };

  // componentDidUpdate(updateProps) {
  //   const { language, loadingShow, showFaq, faq, showError, navigateTo } =
  //     this.props;
  //   var newFaqSlug = this.props.match ? this.props.match.params.slug : false;
  //   if (
  //     (!faq ||
  //       (faq &&
  //         (updateProps.language !== language || faq.slug !== newFaqSlug))) &&
  //     !loadingShow &&
  //     !(showError && showError.slug === newFaqSlug)
  //   ) {
  //     showFaq(newFaqSlug);
  //   } else if (!loadingShow && showError && showError.slug === newFaqSlug) {
  //     navigateTo(`/${language}/faqs/`);
  //   }
  // }

  useSsrEffect(frontload, [
    language,
    faqSlug,
    faq,
    showError,
    loadingShow,
    navigateTo,
    showFaq,
  ]);
  /**
   * renders the faq data
   */

  const title = faq && faq.question ? faq.question : "Loading";
  const image = faq && faq.image ? faq.image : "";
  const published = faq && faq.created_at ? faq.created_at : "";

  // Display text content from answer as meta description if available
  const description =
    faq && faq.answer ? faq.answer.replace(/(<([^>]+)>)/gi, "") : "";

  return (
    <Page
      id="faq"
      className="faq"
      pageType="support"
      title={title}
      image={image}
      published={published}
      description={description}
      lang={language}
    >
      <div className="hero">
        <div className="hero__bg"></div>
        <div className="hero__content">
          <Container>
            <Row>
              <Col sm={12} md={{ size: 6, offset: 3 }}>
                <span className="h1">{context.t("Support Center")}</span>
                <p>
                  {context.t(
                    "Please try first searching our frequently asked questions and help section."
                  )}
                </p>
                <FaqAutocompleteSearch />
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {loadingShow && <LoadingContent />}
      {!loadingShow && loadedShow && faq && <FaqView faq={faq} />}
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Faq.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default connect(mapStateToProps, mapDispatchToProps)(Faq);
